import styled, { css } from 'styled-components'
import { ButtonBase } from 'utils/base'
import PointerC from 'assets/images/Pointer.svg'
const formBreakpoint = '999.9px'

export const DatepickerBaseContainer = styled.div`
  position: relative;
  width: 36rem;
  padding: 1.6rem;
  overflow: hidden;

  border: 1px solid var(--grey-400);
  background-color: var(--light);
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2.4rem;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`

export const DatepickerSwitchHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const DatepickerDayLabel = styled.div`
  width: 4rem;
  text-align: center;
  color: var(--text-light);
  user-select: none;
  font-size: 1.2rem;
  line-height: 2rem;
`

export const DatepickerWeek = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.8rem;
  &:not(:last-child) {
    margin-bottom: 0.8rem;
  }

  @media (max-width:${formBreakpoint}) {
    justify-content: space-between;
  }
`

const DayButtonDot = css`
  &::after {
    content: '';
    width: 0.4rem;
    height: 0.4rem;
    background-color: var(--brand-700);
    border-radius: 50%;
    position: absolute;
    top: 70%;
    left: calc(50% - 0.2rem);
  }
`

const ActiveButton = css`
  background-color: var(--brand-700);
  color: var(--light);
  border-color: var(--brand-700);
  &:hover {
    background-color: var(--brand-700);
    color: var(--light);
    border-color: var(--brand-700);
  }
`

interface DayButtonProps {
  current: boolean
  selected: boolean
}

export const DatepickerDayButton = styled(ButtonBase)<DayButtonProps>`
  position: relative;
  height: 4rem;
  border-radius: .8rem;
  color: var(--text-dark);
  flex: 1 1 4rem;
  user-select: none;
  &:hover {
    background-color: rgba(10, 31, 68, 0.03);
  }
  ${(props) => props.current && DayButtonDot}
  ${(props) => props.selected && ActiveButton}
`

interface SecondaryDayButtonProps extends DayButtonProps {
  blockDay?: boolean
}

export const DatepickerDayButtonSecondary = styled(DatepickerDayButton)<SecondaryDayButtonProps>`
  color: var(--text-disabled);
  ${(props) => props.blockDay && 'pointer-events: none'}
  ${(props) => props.current && DayButtonDot}
  ${(props) => props.selected && ActiveButton}
`

export const DatepickerDaysContainer = styled.div`
  margin: 1.6rem 0;

  @media (max-width:${formBreakpoint}) {
    margin-bottom: 0;
  }
`

export const DatepickerActions = styled(DatepickerSwitchHeader)`
  gap: 0.8rem;
`

const DatepickerActionButton = styled(ButtonBase)`
  flex: 1 1 50%;
  padding: 0.8rem 0;
  border-radius: 6px;
  color: var(--text-medium);
`

export const DatepickerButtonCancel = styled(DatepickerActionButton)`
  background-color: var(--light);
  border: 1px solid var(--grey-400);
  box-shadow: 0px 1px 1px var(--shadow);
`

type AcceptButtonProps = {
  disabled?: boolean
}
export const DatepickerButtonAccept = styled(DatepickerActionButton)<AcceptButtonProps>`
  ${(props) =>
    props.disabled
      ? css`
          background-color: var(--grey-400);
          color: var(--text-disabled);
          border: 1px solid var(--grey-400);
        `
      : ActiveButton}
`

export const Icon = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 3.2rem;
  height: 3.2rem;
  background-color: var(--light);
  border-radius: 6px;
  cursor: url(${PointerC}), auto;
  &:hover {
    background-color: rgba(10, 31, 68, 0.03);
  }
`

export const DatepickerDate = styled.p`
  color: var(--text-medium);
  user-select: none;
`
